<div class="hvac-placeholder-list-item hvac-placeholder-list-item-{{ mode }} hvac-product-list-item hvac-product-list-item-{{ mode }}">
    <div class="hvac-product-list-item-visual">
        <div class="hvac-product-list-item-image hvac-placeholder-list-item-image hvac-placeholder-content hvac-placeholder-content-dark"></div>
    </div>
    <div class="hvac-product-list-item-details">
        <div class="hvac-product-list-item-name hvac-placeholder-list-item-name hvac-placeholder-content hvac-placeholder-content-dark"></div>
        <div class="hvac-product-list-item-modelfamily hvac-placeholder-list-item-modelfamily hvac-placeholder-content hvac-placeholder-content-dark"></div>
    </div>
</div>
